import { render, staticRenderFns } from "./ambiente.vue?vue&type=template&id=5f937f9b"
import script from "./ambiente.vue?vue&type=script&lang=js"
export * from "./ambiente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports